import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ArrowRight, CalendarDays, Zap } from 'lucide-react';
import { Brand } from '../components/ui';
import { MedalArt } from '../components/achievements/MedalArt';
import { publicService } from '../services/api';
import './PublicMedal.css';

/** Medalha compartilhada (/m/:token): só a medalha, o nome da pessoa e o curso. Sem login. */
function PublicMedal() {
  const { token } = useParams();
  const [m, setM] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    publicService.medal(token).then(setM).catch(() => setMissing(true));
  }, [token]);

  useEffect(() => {
    if (m) document.title = `${m.person} conquistou "${m.name}" · StudySpace`;
  }, [m]);

  return (
    <div className="pmd">
      <header className="pmd__top"><a href="/" aria-label="StudySpace"><Brand size="sm" onDark /></a></header>
      <main className="pmd__main">
        {missing ? (
          <p className="pmd__missing">Este link de medalha não existe mais.</p>
        ) : !m ? null : (
          <>
            <MedalArt icon={m.icon} unlocked size={168} />
            <span className="pmd__eyebrow">Medalha conquistada</span>
            <h1 className="pmd__name">{m.name}</h1>
            <p className="pmd__desc">{m.description}</p>
            <p className="pmd__who"><strong>{m.person}</strong>{m.course ? <> · {m.course}</> : null}</p>
            <div className="pmd__chips">
              {m.unlockedAt && (
                <span><CalendarDays size={13} aria-hidden="true" />{new Date(m.unlockedAt).toLocaleDateString('pt-BR', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
              )}
              <span><Zap size={13} aria-hidden="true" />+{m.xp} XP</span>
            </div>
            <a className="pmd__cta" href="/">Conhecer o StudySpace<ArrowRight size={16} aria-hidden="true" /></a>
          </>
        )}
      </main>
    </div>
  );
}

export default PublicMedal;
